<template>
    <div>
        <v-skeleton-loader v-if="loading" type="article"></v-skeleton-loader>
        <div v-else-if="notAnalyzed" class="pa-4 text-center grey--text">
            Звонок ещё не проанализирован
        </div>
        <v-card v-else-if="analysis" flat>
            <v-card-text>
                <div class="mb-2">
                    <v-chip small dark :color="outcomeColor">{{ outcomeText }}</v-chip>
                    <span v-if="analysis.durationSec" class="ml-2 grey--text">{{ analysis.durationSec }} сек.</span>
                </div>

                <div v-if="analysis.summary" class="mb-2">
                    <strong>Резюме:</strong> {{ analysis.summary }}
                </div>
                <div v-if="analysis.clientProblem" class="mb-2">
                    <strong>Проблема клиента:</strong> {{ analysis.clientProblem }}
                </div>
                <div v-if="analysis.outcome === 'REFUSED' && analysis.failureReason" class="mb-2">
                    <strong>Причина отказа:</strong> {{ analysis.failureReason.text }}
                </div>

                <div v-if="analysis.objections && analysis.objections.length" class="mb-2">
                    <strong>Возражения:</strong>
                    <v-chip-group column>
                        <v-chip v-for="(objection, i) in analysis.objections" :key="i" small outlined>
                            {{ objection }}
                        </v-chip>
                    </v-chip-group>
                </div>

                <div class="mb-2">
                    <span class="mr-4">
                        Скрипт: <v-chip x-small dark :color="$helper.aiScoreColor(analysis.scriptScore)">{{ analysis.scriptScore }}</v-chip>
                    </span>
                    <span>
                        Перспективность лида: <v-chip x-small dark :color="$helper.aiScoreColor(analysis.leadQuality)">{{ analysis.leadQuality }}</v-chip>
                    </span>
                </div>
                <div v-if="analysis.scriptIssues" class="mb-2">
                    <strong>Замечания по скрипту:</strong> {{ analysis.scriptIssues }}
                </div>

                <v-expansion-panels v-if="analysis.transcriptText" flat class="mt-3">
                    <v-expansion-panel>
                        <v-expansion-panel-header>Расшифровка</v-expansion-panel-header>
                        <v-expansion-panel-content>
                            <div style="white-space: pre-wrap">{{ analysis.transcriptText }}</div>
                        </v-expansion-panel-content>
                    </v-expansion-panel>
                </v-expansion-panels>
            </v-card-text>
        </v-card>
    </div>
</template>

<script>
import AiService from "../_services/AiService";

const OUTCOME_LABELS = {
    APPOINTMENT_SET: {text: 'Записан', color: 'green'},
    REFUSED: {text: 'Отказ', color: 'red'},
    CALLBACK: {text: 'Перезвон', color: 'purple darken-3'},
    NOT_TARGET: {text: 'Не целевой', color: 'grey'},
    UNCLEAR: {text: 'Неясно', color: 'blue-grey'}
};

export default {
    name: "CallAnalysis",
    props: {
        entryId: String
    },
    data() {
        return {
            analysis: null,
            loading: true,
            notAnalyzed: false
        }
    },
    computed: {
        outcomeText() {
            const label = OUTCOME_LABELS[this.analysis?.outcome];
            return label ? label.text : this.analysis?.outcome;
        },
        outcomeColor() {
            const label = OUTCOME_LABELS[this.analysis?.outcome];
            return label ? label.color : 'grey';
        }
    },
    methods: {
        fetch() {
            this.loading = true;
            this.notAnalyzed = false;
            AiService.getCallAnalysis(this.entryId).then(data => {
                this.analysis = data;
                this.loading = false;
            }, () => {
                this.notAnalyzed = true;
                this.loading = false;
            });
        }
    },
    created() {
        this.fetch();
    }
};
</script>
